import React, { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperNumbers from "../../../helpers/numbers";
import campaigns from "./campaigns";

export default function ViewCampaign() {
  const params = useParams();
  const campaignID = params.id;
  const [campaignName, setCampaignName] = useState();
  const [categoryName, setCategoryName] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [countPosition, setCountPosition] = useState(0);
  const [priceOnDay, setPriceOnDay] = useState(0);
  const [priceEachHour, setPriceEachHour] = useState(0);
  const [countDays, setCountDays] = useState(0);
  const [priceCampaign, setPriceCampaign] = useState(0);
  const [pledge, setPledge] = useState(0);
  const [priceTotal, setPriceTotal] = useState(0);

  useEffect(() => {
    let campaign = campaigns.filter((campaign) => campaign.id == campaignID);
    campaign = campaign[0];
    setCampaignName(campaign.name);
    setStartDate(campaign.start_date);
    setEndDate(campaign.end_date);
    setCountDays(campaign.count_day);
    setCountPosition(campaign.count_position);
    setPriceOnDay(campaign.price_on_day);
    setPriceEachHour(campaign.price_each_hour);
    setPriceCampaign(campaign.price);
    setPledge(campaign.pledge);
    setPriceTotal(campaign.price_total);
    setCategoryName(campaign.category);
  }, []);

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="میزکار" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive pb-4">
                <table className="table table-hilite tbl-td-white-space table-hover m-0">
                  <thead>
                    <tr>
                      <td
                        colspan={2}
                        className="text-center"
                        style={{ borderRadius: "25px 25px 0px 0px" }}
                      >
                        <b>اطلاعات کمپین</b>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <label className="pl-1">نام کمپین : </label>
                      </td>
                      <td>
                        <label className="pr-2">{campaignName}</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="pl-1">
                          نام گروه نمایش دهنده بنری :{" "}
                        </label>
                      </td>
                      <td>
                        <label className="pr-2">{categoryName}</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="pl-1">تعداد جایگاه</label>
                      </td>
                      <td>
                        <label className="pr-2">
                          {helperNumbers.toPersianNum(countPosition)}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="pl-1">تاریخ شروع</label>
                      </td>
                      <td>
                        <span className="number-finance">
                          <label className="pr-2" dir="ltr">
                            {helperNumbers.toPersianNum(startDate)}
                          </label>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="pl-1">تاریخ پایان</label>
                      </td>
                      <td>
                        <span className="number-finance">
                          <label className="pr-2" dir="ltr">
                            {helperNumbers.toPersianNum(endDate)}
                          </label>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>مبلغ یک شبانه روز کمپین</label>
                      </td>
                      <td>
                        <span>
                          <label
                            className=" letter-spacing-finance-number 
                              "
                          >
                            {helperNumbers.toPersianNum(
                              helperNumbers.toFormatFinanceNumber(priceOnDay)
                            )}
                          </label>
                          <label className="pr-2      ">تومان</label>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>مبلغی که در هر ساعت کسر میشود</label>
                      </td>
                      <td>
                        <span>
                          <label
                            className=" letter-spacing-finance-number 
                           "
                          >
                            {helperNumbers.toPersianNum(
                              helperNumbers.toFormatFinanceNumber(priceEachHour)
                            )}
                          </label>
                          <label className=" pr-2     ">تومان</label>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>تعداد شبانه روز کمپین</label>
                      </td>
                      <td>
                        <span>
                          <label>{helperNumbers.toPersianNum(countDays)}</label>
                          <label className="pr-2">شبانه روز</label>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>مبلغ کمپین</label>
                      </td>
                      <td>
                        <span>
                          <label
                            className=" letter-spacing-finance-number 
                            "
                          >
                            {helperNumbers.toPersianNum(
                              helperNumbers.toFormatFinanceNumber(priceCampaign)
                            )}
                          </label>
                          <label
                            className=" pr-2  
    "
                          >
                            تومان
                          </label>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>مبلغ بیعانه کمپین</label>
                      </td>
                      <td>
                        <span>
                          <label
                            className=" letter-spacing-finance-number 
                        "
                          >
                            {helperNumbers.toPersianNum(
                              helperNumbers.toFormatFinanceNumber(pledge)
                            )}
                          </label>
                          <label
                            className=" px-2  
                         "
                          >
                            تومان
                          </label>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>مبلغ کل کمپین</label>
                      </td>
                      <td>
                        <span>
                          <label
                            className=" letter-spacing-finance-number 
                         "
                          >
                            {helperNumbers.toPersianNum(
                              helperNumbers.toFormatFinanceNumber(priceTotal)
                            )}
                          </label>
                          <label
                            className=" px-2  
                           "
                          >
                            تومان
                          </label>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
